module.exports = __webpack_public_path__ + "img/register.7c4884b0.svg";